import React from 'react';
import { Dialog, DialogContent, Tabs, Tab, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DialogsContext } from '../../context/dialogsContext';
import { CurrentCohortSubscriptionContext } from '../../context/currentCohortSubscriptionContext';
import StructuredGuidance from './StructuredGuidance';
import { validateGuidanceItems, getCaseTypeContent } from './caseTypeContent';

const tabs = [
  { key: 'Simple', label: 'Simple' },
  { key: 'Complex', label: 'Complex' },
  { key: 'Psych', label: 'Psych' }
] as const;

const CaseTypesDialog: React.FC = () => {
  const { showCaseTypesDialog, setShowCaseTypesDialog } = React.useContext(DialogsContext);
  const { currentCohortSubscription } = React.useContext(CurrentCohortSubscriptionContext);
  const [tabIndex, setTabIndex] = React.useState(0);

  const handleClose = () => setShowCaseTypesDialog(false);

  const activeTab = tabs[tabIndex].key;
  const courseId = currentCohortSubscription?.cohort?.course?.id;
  const effectiveContent = React.useMemo(() => getCaseTypeContent(courseId), [courseId]);
  const tabContent = effectiveContent[activeTab];
  React.useEffect(() => {
    if (tabContent && !validateGuidanceItems(tabContent.items)) {
      // eslint-disable-next-line no-console
      console.warn('Invalid guidance items structure for tab', activeTab);
    }
  }, [activeTab, tabContent]);

  return (
    <Dialog
      open={showCaseTypesDialog}
      onClose={handleClose}
      fullWidth
      maxWidth='lg'
      PaperProps={{ sx: { minHeight: '80vh', display: 'flex', flexDirection: 'column' } }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', borderBottom: 1, borderColor: 'divider', px: 2 }}>
        <Box sx={{ flex: 1, minWidth: 0, overflowX: 'auto' }}>
          <Tabs
            value={tabIndex}
            onChange={(_, v) => setTabIndex(v)}
            variant='scrollable'
            scrollButtons='auto'
            allowScrollButtonsMobile
            TabIndicatorProps={{ sx: { height: 4, backgroundColor: 'primary.main' } }}
            sx={{
              minHeight: 48,
              '& .MuiTabs-flexContainer': {
                gap: 2
              }
            }}
          >
            {tabs.map((tab) => (
              <Tab
                key={tab.key}
                label={
                  <span style={{ fontSize: 16, fontWeight: 600, letterSpacing: 0.5 }}>
                    {tab.label}
                  </span>
                }
                sx={{
                  textTransform: 'none',
                  minHeight: 48,
                  fontWeight: 600,
                  color: 'text.primary',
                  opacity: 1,
                  flexShrink: 0
                }}
                disableRipple
              />
            ))}
          </Tabs>
        </Box>
        <IconButton onClick={handleClose} sx={{ flexShrink: 0, ml: 1 }} aria-label='close'>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 4, flex: 1, overflowY: 'auto' }}>
        {tabContent && <StructuredGuidance items={tabContent.items} />}
      </DialogContent>
    </Dialog>
  );
};

export default CaseTypesDialog;
